import { InjectionToken } from '@angular/core';

export interface Spacer {
  width: number;
  height: number;
}

export interface GALAXY_LIST_OPTIONS {
  /**
   * Dimension of the spacer used to offset the content when no icon is present, but the item is
   * nested in a container that does have an icon. Interpret this value as follows: "The parent
   * sublist header has an element that is sublistContentSpacer pixels wide and tall. This element
   * or family of elements (such as icons) may or may not be present in each item in the sublist
   * content. If not present, an empty element with matching dimensions is inserted to ensure all
   * remaining content is aligned with the set of elements in the parent sublist header which are
   * a equivalent to the set of all elements included in the sublist item." For example:
   *
   * given a parent header:         [____icon___] [text] [badge]
   * and a sublist item:            [text] [badge]
   * and a sublist item with icon:  [____icon___] [text] [badge]
   *
   * we inject a [icon_spacer] element with dimensions [icon] to ensure the text and badge are aligned
   * with the icon in the parent header.
   *
   * The rendered sublist item:     [icon_spacer] [text] [badge]
   * The second sublist item:       [____icon___] [text] [badge]
   *
   * It is up to individual list item components to apply this value as applicable.
   *
   * @default{ width: 24, height: 24 }
   * @type number
   *
   */
  sublistContentSpacer: Spacer;

  /**
   * designVersion is used to apply a different design language to list components.
   *
   * @default 'legacy'
   */
  designVersion: 'default' | 'legacy';
}

export const GALAXY_LIST_OPTIONS_TOKEN = new InjectionToken<GALAXY_LIST_OPTIONS>('GalaxyListOptions');
